import { graphql, HttpResponse } from 'msw'
import {
  EnrollmentInvestmentExperienceCategory,
  EnrollmentInvestmentObjectiveCategory,
  type EnrollmentJointInvestmentGoalsData,
  type EnrollmentJointInvestmentGoalsSubmitOutput,
} from '../../../../models'

export const getEnrollmentJointInvestmentGoalsDataMock: EnrollmentJointInvestmentGoalsData = {
  isError: false,
  errors: [],
  activePerson: {
    applicationId: 'test-application-id-123',
    progress: 70,
    path: '/enrollment/joint/investment-goals',
    investmentExperience: EnrollmentInvestmentExperienceCategory.VERY_LITTLE,
    investmentObjective: EnrollmentInvestmentObjectiveCategory.GENERATE_INCOME,
    name: {
      firstName: 'Jonathan',
      lastName: 'Smith',
    },
  },
}

export const submitEnrollmentJointInvestmentGoalsDataMock: EnrollmentJointInvestmentGoalsSubmitOutput = {
  isError: false,
  errors: [],
  activePerson: {
    path: '/enrollment/joint/bd-shareholder',
  },
}

export const mockGetEnrollmentJointInvestmentGoalsData = graphql.mutation(
  'getEnrollmentJointInvestmentGoalsData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointInvestmentGoalsDataMock } })
  },
)

export const mockSubmitEnrollmentJointInvestmentGoalsData = graphql.mutation(
  'submitEnrollmentJointInvestmentGoalsData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointInvestmentGoalsDataMock } })
  },
)

export const mockEnrollmentJointInvestmentGoals = [
  mockGetEnrollmentJointInvestmentGoalsData,
  mockSubmitEnrollmentJointInvestmentGoalsData,
]
